module.exports = __webpack_public_path__ + "static/media/Delete-Dashboard-screenshot.17719add.png";